export default __webpack_public_path__ + "static/Inter-ExtraLight-1815b9a8a67debdb396622502a58db17.ttf";